import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("container", component(opts));
  editor.BlockManager.add("container", block(opts));
};